import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

import { Brand } from "../../../../configurations";
import Challenges from "../../../Challenges";
import Rewards from "../../../../segmentedComponents/Rewards";
import { BrandUtils } from "../../../../utils/brandUtils";

const getNotificationBox = (brandId, handleClick) => {
  let notificationBox = <Rewards onClick={handleClick} />;
  let isMultipleNotificationBox = false;

  switch (brandId) {
    case Brand.Sport_SH: {
      notificationBox = null;
      break;
    }
    case Brand.Sport_Com:
    case Brand.Sport_CA:
    case Brand.Sport_NL: {
      isMultipleNotificationBox = true;
      notificationBox = (
        <React.Fragment>
          <Challenges iconName="challenges" onClick={handleClick} />
          <Rewards onClick={handleClick} />
        </React.Fragment>
      );
      break;
    }
    case Brand.Sport_CO:
    case Brand.Sport_VA:
    case Brand.Sport_IN:
    case Brand.Sport_MI: {
      isMultipleNotificationBox = true;
      notificationBox = (
        <React.Fragment>
          <Challenges iconName="locker" onClick={handleClick} />
          <Rewards onClick={handleClick} />
        </React.Fragment>
      );
      break;
    }
    case Brand.Sport_Spoker: {
      if (BrandUtils.isPokerClient()) {
        isMultipleNotificationBox = true;
        notificationBox = (
          <React.Fragment>
            <Challenges iconName="challanges-shield" onClick={handleClick} />
            <Rewards onClick={handleClick} />
          </React.Fragment>
        );
      }
      break;
    }
  }

  const className = classNames("aCnotificationsBox", {
    multipleNotificationBox: isMultipleNotificationBox
  });

  return <div className={className}>{notificationBox}</div>;
};

const NotificationBox = ({ handleClick, brandId }) => {
  return <>{getNotificationBox(brandId, handleClick)}</>;
};

NotificationBox.propTypes = {
  brandId: PropTypes.number,
  handleClick: PropTypes.func
};

export default React.memo(NotificationBox);
